import { useCallback, useState } from "react";

export function useLocalStorage<T>(input: { key: string; defaultValue: T }) {
  const read = (): T => {
    if (typeof window === "undefined") {
      return input.defaultValue;
    }
    const raw = window.localStorage.getItem(input.key);
    if (raw === null) {
      return input.defaultValue;
    }
    try {
      return JSON.parse(raw) as T;
    } catch {
      return input.defaultValue;
    }
  };

  const [value, setValue] = useState<T>(read);

  const setStoredValue = useCallback(
    (next: T | ((current: T) => T)) => {
      setValue((current) => {
        const resolved = typeof next === "function" ? (next as (c: T) => T)(current) : next;
        window.localStorage.setItem(input.key, JSON.stringify(resolved));
        return resolved;
      });
    },
    [input.key]
  );

  return [value, setStoredValue] as const;
}
